import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { DataTableModule } from 'primeng/primeng';
import { FlexLayoutModule } from '@angular/flex-layout';

import { RuleComponent } from './rule.component';
import { RuleGroupListComponent } from './rulegrouplist/rulegroup-list.component';
import { RuleListComponent } from './rulelist/rule-list.component';
import { RuleGroupMappingListComponent } from './rulegroupmappinglist/rulegroupmapping-list.component';
import { RuleParamListComponent } from './ruleparamlist/ruleparam-list.component';
import { AddRuleGroupComponent } from './addrulegroup/add-rulegroup.component';
import { AddRuleComponent } from './addrule/add-rule.component';
import { AddRuleGroupMappingComponent } from './addrulegroupmapping/add-rulegroupmapping.component';
import { AddRuleParamComponent } from './addruleparam/add-ruleparam.component';
import { RuleManagementService } from './rule-management.service';
import { RuleParamService } from './rule-param.service';

@NgModule({
    declarations: [RuleComponent, RuleGroupListComponent, RuleListComponent, AddRuleGroupComponent, AddRuleComponent, RuleGroupMappingListComponent, AddRuleGroupMappingComponent, RuleParamListComponent, AddRuleParamComponent],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
    ],
    providers: [RuleManagementService,RuleParamService],
    entryComponents: [
        AddRuleGroupComponent,
        AddRuleComponent,
        AddRuleGroupMappingComponent,
        AddRuleParamComponent,
    ]

})

/**
 * Main module for the rule managements.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
*/

export class RuleModule { }





// WEBPACK FOOTER //
// ./src/app/admin/rules/rule.module.ts